
  import { defineComponent, ref, reactive, onMounted } from 'vue'
  import { ElMessage, ElMessageBox } from 'element-plus'
  import { getClassRoomList, editClassTeath, deleteClassTeath, addClassTeath, getGeoArea } from '@/service/main/system/system'
  import type { FormInstance } from 'element-plus'
  export default defineComponent({
    name: 'SchoolSetting',
    setup() {
      // 表格数据
      const tableData = ref<any[]>([])
      
      // 表单数据
      const formData = reactive({
        id: '',
        name: '',
        pid: '0',
        type: '1',
        locationProvince: '',
        locationCity: '',
        locationCounty: '',
        locationDetail: ''
      })
      
      // 校区选项
      const schoolOptions = ref<any[]>([])
      
      // 地区相关
      const areaValue = ref('')
      const geoAreaList = ref<any[]>([])
      
      // 表单规则
      const rules = {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        type: [{ required: true, message: '请选择类型', trigger: 'change' }],
        pid: [{ required: true, message: '请选择校区', trigger: 'change' }]
      }
      
      // 弹窗相关
      const dialogVisible = ref<boolean>(false)
      const dialogTitle = ref<string>('新增')
      const isEdit = ref<boolean>(false)
      const formRef = ref<FormInstance | null>(null)
      
      // 获取数据列表
      const getDataList = async () => {
        try {
          const res:any = await getClassRoomList('/pc/classRoom/list',{})
            tableData.value = res.rows || []
            
            schoolOptions.value = tableData.value.filter(item => item.type === '1')
          
        } catch (error) {
          console.error('获取数据失败:', error)
          ElMessage.error('获取数据失败')
        }
      }
      
      // 获取地区数据
      const getGeoAreaList = async () => {
        try {
          const res: any = await getGeoArea('/app/area/getAreaTree', {
            type: 0
          })
          geoAreaList.value = res?.data || []
        } catch (error) {
          console.error('获取地区数据失败:', error)
        }
      }
      
      // 处理地区变化
      const handleAreaChange = (value: string) => {
        // 找到对应的省市区信息
        for (const province of geoAreaList.value) {
          for (const city of province.child || []) {
            for (const county of city.child || []) {
              if (county.id === value) {
                formData.locationProvince = province.name
                formData.locationCity = city.name
                formData.locationCounty = county.name
                return
              }
            }
            if (city.id === value) {
              formData.locationProvince = province.name
              formData.locationCity = city.name
              formData.locationCounty = ''
              return
            }
          }
        }
      }
      
      // 处理类型变化
      const handleTypeChange = (val: string) => {
        // 当选择校区时，pid设为0
        if (val === '1') {
          formData.pid = '0'
          // 清空地区信息
          formData.locationProvince = ''
          formData.locationCity = ''
          formData.locationCounty = ''
          areaValue.value = ''
        } else {
          // 当选择教室时，如果没有选择校区，将默认选择第一个校区
          if (schoolOptions.value.length > 0 && formData.pid === '0') {
            formData.pid = schoolOptions.value[0].id
          }
        }
      }
      
      // 点击新增按钮
      const handleAddClick = () => {
        isEdit.value = false
        dialogTitle.value = '新增'
        dialogVisible.value = true
        // 重置表单
        resetForm()
      }
      
      // 点击编辑按钮
      const handleEditClick = (row: any) => {
        isEdit.value = true
        dialogTitle.value = '编辑'
        dialogVisible.value = true
        // 填充表单数据
        Object.assign(formData, {
          id: row.id,
          name: row.name,
          pid: row.pid,
          type: row.type,
          locationProvince: row.locationProvince || '',
          locationCity: row.locationCity || '',
          locationCounty: row.locationCounty || '',
          locationDetail: row.locationDetail || ''
        })
        
        // 如果有地区数据，设置地区选择的值
        if (row.locationCounty) {
          // 需要找到对应的地区ID
          for (const province of geoAreaList.value) {
            for (const city of province.child || []) {
              for (const county of city.child || []) {
                if (county.name === row.locationCounty && 
                    city.name === row.locationCity && 
                    province.name === row.locationProvince) {
                  areaValue.value = county.id
                  break
                }
              }
            }
          }
        }
      }
      
      // 点击删除按钮
      const handleDeleteClick = (row: any) => {
        ElMessageBox.confirm(`确认删除${row.type === '1' ? '校区' : '教室'} "${row.name}" 吗?`, '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          try {
            const res:any = await deleteClassTeath('/pc/classRoom/remove', {
              id: row.id,
              type: row.type
            })
              ElMessage.success('删除成功')
              getDataList()
            
          } catch (error) {
            console.error('删除失败:', error)
            ElMessage.error('删除失败')
          }
        }).catch(() => {
          // 取消删除
        })
      }
      
      // 确认按钮点击
      const handleConfirm = () => {
        if (!formRef.value) return
        
        formRef.value.validate(async (valid: boolean) => {
          if (valid) {
            try {
              const url = isEdit.value ? '/pc/classRoom/edit' : '/pc/classRoom/add'
              const res:any = await isEdit.value ?editClassTeath(url, formData):addClassTeath(url, formData)
                ElMessage.success(isEdit.value ? '编辑成功' : '新增成功')
                setTimeout(() => {
                  getDataList()
                dialogVisible.value = false

                }, 2000);
              
            } catch (error) {
              console.error(isEdit.value ? '编辑失败:' : '新增失败:', error)
              ElMessage.error(isEdit.value ? '编辑失败' : '新增失败')
            }
          }
        })
      }
      
      // 重置表单
      const resetForm = () => {
        formData.id = ''
        formData.name = ''
        formData.type = '1'
        formData.pid = '0'
        formData.locationProvince = ''
        formData.locationCity = ''
        formData.locationCounty = ''
        formData.locationDetail = ''
        areaValue.value = ''
        
        // 重置表单验证
        formRef.value?.resetFields()
      }
      
      onMounted(() => {
        getDataList()
        getGeoAreaList()
      })
      
      return {
        tableData,
        formData,
        dialogVisible,
        dialogTitle,
        formRef,
        rules,
        schoolOptions,
        areaValue,
        geoAreaList,
        handleTypeChange,
        handleAreaChange,
        handleAddClick,
        handleEditClick,
        handleDeleteClick,
        handleConfirm,
        resetForm
      }
    }
  })
  